"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoolioManualCommandsValidation = void 0;
const CoolioControlModeValidation_1 = require("./CoolioControlModeValidation");
class CoolioManualCommandsValidation {
    static isValid(entity) {
        // If entity.coolio_en exists, validate that it has the correct type.
        if (entity.coolio_en != undefined) {
            if (typeof entity.coolio_en !== "boolean")
                return false;
        }
        // If entity.kiosk_charging exists, validate that it has the correct type.
        if (entity.kiosk_charging != undefined) {
            if (typeof entity.kiosk_charging !== "boolean")
                return false;
        }
        // If entity.manual_mode exists, validate that it has the correct type.
        if (entity.manual_mode != undefined) {
            if (typeof entity.manual_mode !== "boolean")
                return false;
        }
        // If entity.fan1_mode exists, validate that it has the correct type.
        if (entity.fan1_mode != undefined) {
            if (!CoolioControlModeValidation_1.CoolioControlModeValidation.isValid(entity.fan1_mode))
                return false;
        }
        // If entity.fan1_setpoint exists, validate that it has the correct type.
        if (entity.fan1_setpoint != undefined) {
            if (typeof entity.fan1_setpoint !== "number")
                return false;
        }
        // If entity.fan2_mode exists, validate that it has the correct type.
        if (entity.fan2_mode != undefined) {
            if (!CoolioControlModeValidation_1.CoolioControlModeValidation.isValid(entity.fan2_mode))
                return false;
        }
        // If entity.fan2_setpoint exists, validate that it has the correct type.
        if (entity.fan2_setpoint != undefined) {
            if (typeof entity.fan2_setpoint !== "number")
                return false;
        }
        // If entity.fan3_mode exists, validate that it has the correct type.
        if (entity.fan3_mode != undefined) {
            if (!CoolioControlModeValidation_1.CoolioControlModeValidation.isValid(entity.fan3_mode))
                return false;
        }
        // If entity.fan3_setpoint exists, validate that it has the correct type.
        if (entity.fan3_setpoint != undefined) {
            if (typeof entity.fan3_setpoint !== "number")
                return false;
        }
        // If entity.fan4_mode exists, validate that it has the correct type.
        if (entity.fan4_mode != undefined) {
            if (!CoolioControlModeValidation_1.CoolioControlModeValidation.isValid(entity.fan4_mode))
                return false;
        }
        // If entity.fan4_setpoint exists, validate that it has the correct type.
        if (entity.fan4_setpoint != undefined) {
            if (typeof entity.fan4_setpoint !== "number")
                return false;
        }
        // If entity.heater_mode exists, validate that it has the correct type.
        if (entity.heater_mode != undefined) {
            if (!CoolioControlModeValidation_1.CoolioControlModeValidation.isValid(entity.heater_mode))
                return false;
        }
        // If entity.heater_setpoint exists, validate that it has the correct type.
        if (entity.heater_setpoint != undefined) {
            if (typeof entity.heater_setpoint !== "number")
                return false;
        }
        // If entity.pump_mode exists, validate that it has the correct type.
        if (entity.pump_mode != undefined) {
            if (!CoolioControlModeValidation_1.CoolioControlModeValidation.isValid(entity.pump_mode))
                return false;
        }
        // If entity.pump_setpoint exists, validate that it has the correct type.
        if (entity.pump_setpoint != undefined) {
            if (typeof entity.pump_setpoint !== "number")
                return false;
        }
        // If entity.pump_reverse exists, validate that it has the correct type.
        if (entity.pump_reverse != undefined) {
            if (typeof entity.pump_reverse !== "boolean")
                return false;
        }
        // If entity.pump_shutoff exists, validate that it has the correct type.
        if (entity.pump_shutoff != undefined) {
            if (typeof entity.pump_shutoff !== "boolean")
                return false;
        }
        return true;
    }
}
exports.CoolioManualCommandsValidation = CoolioManualCommandsValidation;
